import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "div-history w-full mtop-06" }
const _hoisted_4 = { class: "row w-full" }

import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from "vue-i18n";
import EsDataCard from '@/components/esDataCard.vue';
import { InstituteApi, LastPatientsResponse } from '@/apiGenerate/medserver';
import {medServerApiConfig} from '@/config/medserver-api.config';
import { ApiError, DateFormat } from '@/models/share.model';
import { format } from 'date-fns';
import { useAppUserStore } from '@/stores/appUser';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { useUiStore } from '@/stores/ui';
import { useRouter } from 'vue-router';
import { formatTime } from '@/utils/date-utils';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import PersonService from '@/services/PersonService';

type LastPatientsResponseWithId = LastPatientsResponse & { id?: string };

export default /*@__PURE__*/_defineComponent({
  __name: 'esPlanningHistory',
  props: {
    selectedDate: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const instituteApi = new InstituteApi(medServerApiConfig);

const appUserStore = useAppUserStore();
const currentEntryStore = useCurrentEntryStore();
const toast = useToast();
const uiStore = useUiStore();
const router = useRouter();

const historyPatients = ref<LastPatientsResponseWithId[]>([]);

const currInstituteUUID = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {return "";}
  return appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId || "";
});

const getEntryList = async() => {
  if (currInstituteUUID.value && props.selectedDate) {
    await instituteApi.listLastPatientsByInstitute({instituteId: currInstituteUUID.value, specificDate: format(new Date(props.selectedDate), DateFormat.ISO_SMALL)}).then((res: LastPatientsResponse[]) => {
      historyPatients.value = res;
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: t(`error.${error.status}`)
      });
    });
  }
}

const setLoadingScreenTexts = (patient: LastPatientsResponse) => {
  const loadingText = PersonService.formatName(patient.lastname, patient.firstname);
  const loadingSubText = format(new Date(patient.birthdate), DateFormat.FRONT_LONG);

  uiStore.setLoadingScreenText(loadingText)
  uiStore.setLoadingScreenSubText(loadingSubText)
}

const accessPatient = (patient: LastPatientsResponse) => {
  currentEntryStore.clearCurrentEntry();
  setLoadingScreenTexts(patient)
  router.push({
    name: "patient",
    params: { patientId: patient.patientId
     }
  })
}

watch(currInstituteUUID, async (newVal) => {
  if (newVal) {
    await getEntryList();
  }
});

watch(
  () => props.selectedDate,
  async () => {
    await getEntryList();
  }
);

onMounted(async () => {
  getEntryList();
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('calendar.history.title') + ':',
        styles: "font-lBold",
        class: "mleft-08"
      }, null, 8, ["txt"]),
      _createVNode(_component_text_item, {
        txt: _unref(format)(new Date(_ctx.selectedDate), _unref(DateFormat).FRONT_LONG),
        styles: "font-lBold main-h",
        class: "mleft-06"
      }, null, 8, ["txt"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyPatients.value, (historyPatient) => {
        return (_openBlock(), _createBlock(EsDataCard, {
          key: historyPatient.id,
          class: "history-content mtop-04",
          compact: true,
          usePadS: false,
          title: _unref(PersonService).formatHonorificAndName(historyPatient.gender, historyPatient.lastname, historyPatient.firstname),
          backgroundClass: "bg-grey-016",
          txtClass: "font-bold-600",
          onClick: ($event: any) => (accessPatient(historyPatient))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_text_item, {
                txt: _unref(formatTime)(historyPatient.lastVisitDateTime),
                class: "mleft-06"
              }, null, 8, ["txt"])
            ])
          ]),
          _: 2
        }, 1032, ["title", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})